import { ReactNode } from "react";
import { Collapse, SxProps, TableCell, TableRow, Theme } from "@mui/material";

export type DetailRowProps = {
  children: ReactNode;
  colSpan: number;
  open: boolean;
  id?: string;
  backgroundColor?: string;
  tdSx?: SxProps<Theme>;
};

export function DetailRow({
  children,
  colSpan,
  open,
  id,
  backgroundColor,
  tdSx,
}: DetailRowProps) {
  return (
    <TableRow
      id={id}
      className="detail-row"
      sx={{
        borderBottom: "none",
        ...(backgroundColor && { backgroundColor }),
        "&:hover": { backgroundColor: backgroundColor ?? "unset" },
      }}
    >
      <TableCell
        colSpan={colSpan}
        sx={[{ p: 0, maxWidth: 0 }, ...(Array.isArray(tdSx) ? tdSx : [tdSx])]}
      >
        <Collapse in={open} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      </TableCell>
    </TableRow>
  );
}
